import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from '../../network/APIEndpoints'
import { sitConfigQrAgentPortal } from '../../network/config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const activateQrReq = (mid: string, tid: string, vpa: string, mobile: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.ActivateQr,
    method: 'POST',
    config: sitConfigQrAgentPortal(tokens),
    body: {
      merchantId: mid,
      csoMobile: {
        countryCode: '91',
        number: mobile,
      },
      vpa: vpa,
      terminalId: tid,
    },
  }

  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { activateQrReq }
